import { render, staticRenderFns } from "./PUIEdit.vue?vue&type=template&id=125185d2&scoped=true&"
import script from "./PUIEdit.vue?vue&type=script&lang=js&"
export * from "./PUIEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125185d2",
  null
  
)

export default component.exports